/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WelcomeBeaconResponse interface.
 */
export function instanceOfWelcomeBeaconResponse(value) {
    if (!('ok' in value) || value['ok'] === undefined)
        return false;
    return true;
}
export function WelcomeBeaconResponseFromJSON(json) {
    return WelcomeBeaconResponseFromJSONTyped(json, false);
}
export function WelcomeBeaconResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ok': json['ok'],
    };
}
export function WelcomeBeaconResponseToJSON(json) {
    return WelcomeBeaconResponseToJSONTyped(json, false);
}
export function WelcomeBeaconResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ok': value['ok'],
    };
}
